const processItem = (item) => ({
  uid: item.uid,
  name: item.name,
  parent_uid: item.parentUid,
  concepts_count: item.conceptsCount || 0,
  practice_session_color: item.practiceSessionColor || null,
  parent_name: item.parentName || '',
  practice_session_exists: item.practiceSessionExists || false,
  free_question_count: item.freeQuestionCount || 0,
  total_question_count: item.totalQuestionCount || 0
});

const processTopologyData = (data) => {
  if (data.processed) {
    return data;
  }

  return {
    processed: true,
    uid: data.uid,
    name: data.name,
    children_topics: (data.childrenTopics || []).map((topic) => ({
      ...processItem(topic),
      children_concepts: (topic.childrenConcepts || []).map((concept) =>
        processItem(concept)
      )
    })),
    practice_session_color: data.practiceSessionColor
  };
};

export default processTopologyData;
